import { COLORS } from '@alto/design-library-tokens';
import { Body } from '@alto/design-system';
import React, { useEffect, useState } from 'react';
import { useCartSelectedPricingInfoForPrescription } from '~shared/features/prescriptions/hooks/useCartSelectedPricingInfoForPrescription';
import { formatDollars } from '~shared/helpers/currency';

type Props = {
  readonly prescriptionID: number;
};

export default function SavingsAppliedTag({ prescriptionID }: Props) {
  const [savingsApplied, setSavingsApplied] = useState<number>(0);
  const { savingsAppliedAmount } = useCartSelectedPricingInfoForPrescription({ prescriptionID });

  useEffect(() => {
    if (savingsAppliedAmount) {
      setSavingsApplied(savingsAppliedAmount);
    }
  }, [savingsAppliedAmount]);

  if (savingsApplied === 0) {
    return null;
  }

  return (
    <>
      <Body
        fontFamily="bold"
        textSize="mini"
        color={COLORS.TEXT_COLORS.SUCCESS}
      >
        Savings Applied
      </Body>
      <Body
        fontFamily="bold"
        textSize="mini"
        color={COLORS.TEXT_COLORS.SUCCESS}
      >
        -{formatDollars(savingsApplied)}
      </Body>
    </>
  );
}
